<!--
  zym.音像
  材料展示组件，材料Data从上个页面传递过来
 -->

<template>
  <div class="pressTabList">
    <div class="rejects" v-if="opMsg">
      <div class="rejLine">
        <div class="rejName">状态：</div>
        <div class="rejText" v-if="msgStatus == 21">暂缓登记</div>
        <div class="rejText" v-if="msgStatus == 3">退回</div>
        <!-- <div class="rejText">退回</div> -->
      </div>
      <div class="rejLine">
        <div class="rejName">原因：</div>
        <div class="rejText">
          <!-- {{ opMsg }} -->
          <div v-for="(item, index) in (opMsg || '').split('；')" :key="index" style="text-align: left">
            {{ item ? item + (index == (opMsg || "").split("；").length - 1 ? "" : "；") : "" }}
          </div>
        </div>
      </div>
    </div>

    <div class="headBar">
      <span>材料1：工作总结&nbsp;&nbsp;&nbsp; </span>

      <span style="color: red; float: right"
        >工作提醒：本系统为非涉密信息系统，请严格遵守相关保密工作规定，切勿上传任何涉密信息及文件。</span
      >
      <!-- <el-select v-model="selYear" @change="valChange" size="medium" placeholder="历年记录" style="float: right">
        <el-option v-for="item in selYearRecord" :key="item.value" :label="item.label" :value="item.value"> </el-option>
      </el-select> -->
    </div>

    <!-- zym.工作总结 -->
    <div class="tabArea">
      <el-table :data="tabCage.tabDat1" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column prop="materialTitle" label="材料名称" align="center"> </el-table-column>
        <el-table-column label="完成进度" align="center">
          <template slot-scope="scope">
            {{ scope.row.status | translate("pgress") }}
          </template>
        </el-table-column>
        <el-table-column label="更新时间" align="center">
          <template slot-scope="scope">
            {{ scope.row | translate("time") }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <!-- pubStatus，比对的是核验阶段，出版社阶段返回0，否则返回1 -->
            <UpBtn
              v-if="pubStatus == 1 || pubStatus == 0"
              :fileID="zeroStoreage[scope.row.id] ? zeroStoreage[scope.row.id].fileId : ''"
              :btnProps="scope.row"
              @zeroTabStore="zeroStoreCtrls"
              :pubStatus="
                (scope.row.materialTitle == '整改报告' && pubStatus == 0 && isModifyStage == '1') ||
                (scope.row.materialTitle != '整改报告' && pubStatus == 0)
                  ? 0
                  : 1
              " />
            <!-- <UpBtn v-if="pubStatus==1 || (pubStatus==0 && scope.row.materialTitle!='整改报告')"
            :fileID="zeroStoreage[scope.row.id] ? zeroStoreage[scope.row.id].fileId : ''" :btnProps="scope.row"
              @zeroTabStore="zeroStoreCtrls" :pubStatus="pubStatus" /> -->

            <!-- <el-button disabled size="mini" type="primary"
            v-if="pubStatus==0 && scope.row.materialTitle=='整改报告'" >
            上传
          </el-button> -->
          </template>
          <!-- <template slot-scope="scope">
                                                                                                                                                                                                                                          {{zeroStoreage[scope.row.id]}}
                                                                                                                                                                                                                                         </template> -->
        </el-table-column>
      </el-table>
      <div class="tabTips">注：上传文件格式为WORD，文件大小不超过100M</div>
    </div>

    <!-- zym.材料2 - 填报信息 -->
    <div class="headBar">
      <!-- <span v-if="pressType == 1">材料2：音像制品出版单位年度核验表、音像制品出版情况表</span>
      <span v-if="pressType == 2">材料2：电子出版物出版单位年度核验表、电子出版物出版情况表</span> -->
      <span v-if="pressType == 1"
        >材料2：音像制品出版单位年度核验表、音像制品出版情况表（<span style="color: red"
          >如果已经填写了电子数据，部分表格可以通过数据拷贝的方式获取</span
        >）</span
      >
      <span v-if="pressType == 2"
        >材料2：电子出版物出版单位年度核验表、电子出版物出版情况表（<span style="color: red"
          >如果已经填写了音像数据，部分表格可以通过数据拷贝的方式获取</span
        >）</span
      >

      <el-button class="copyBtn" @click="copyHandle('show')" type="warning" size="mini">数据拷贝</el-button>
      <!-- <a :href="filrUrl1" class="downBtn" download><el-button size="mini">下载导入模板</el-button></a> -->
      <a v-if="pressType == 1" :href="filrUrl1" class="downBtn" download>
        <el-button size="mini">下载封面和盖章页</el-button>
      </a>
      <a v-if="pressType == 2" :href="filrUrl2" class="downBtn" download>
        <el-button size="mini">下载封面和盖章页</el-button>
      </a>
    </div>
    <div class="subBar">
      <span v-if="pressType == 1">表1：音像制品出版单位年度核验表</span>
      <span v-if="pressType == 2">表1：电子出版物出版单位年度核验表</span>
    </div>

    <div class="tabArea">
      <table class="tabElement">
        <tr class="tabHead">
          <td>序号</td>
          <td>材料名称</td>
          <td>完成进度</td>
          <td>更新时间</td>
          <td colspan="2">操作</td>
        </tr>
        <tr v-for="(item, inx) in tabCage.tabDat2" key="inx">
          <td>1-{{ inx + 1 }}</td>
          <td>{{ item.materialTitle }}</td>
          <td>{{ item.status | translate("pgress") }}</td>
          <td>{{ item | translate("time") }}</td>
          <td style="width: 120px">
            <el-button v-if="pubStatus == 0 && item.status == 1" type="primary" @click="toEdit(item, 1)" size="mini"
              >填表</el-button
            >
            <el-button v-if="pubStatus == 0 && item.status == 2" type="danger" @click="toEdit(item, 2)" size="mini"
              >修改</el-button
            >
            <el-button v-if="pubStatus == 1" type="primary" @click="toEdit(item, 3)" size="mini">查看</el-button>
          </td>
          <td style="width: 120px" v-if="inx == 0" rowspan="7">
            <a href="javascript:void(0);" @click="dmyfile(1)" downLoad>
              <el-button size="mini">导出打印表</el-button>
            </a>
          </td>
          <td v-else-if="inx == 7">
            <a href="javascript:void(0);" @click="dmyfile(2)" downLoad>
              <el-button size="mini">导出打印表</el-button>
            </a>
          </td>
          <td v-else-if="inx == 8"></td>
        </tr>
        <!-- zym.20230404新增加 -->
        <!-- <tr >
        <td>1-9</td>
        <td>出版经营情况调查表</td>
        <td>&nbsp;</td>
        <td>&nbsp;</td>
        <td style="width:120px;">
          <el-button type="primary" @click="toEdit({materialCode:'210'}, 1)"
            size="mini">填表</el-button>
                </td>
                <td style="width:120px;" >
                  &nbsp;
        </td>
      </tr> -->
      </table>

      <!-- <div class="tabArea">
    <el-table :data="tabCage.tabDat2" border style="width: 100%">
      <el-table-column prop="date" label="序号" width="60" align="center" type="index">
        <template slot-scope="scope">
                         1-{{ scope.$index + 1 }}
                     </template>
      </el-table-column>
      <el-table-column prop="materialTitle" label="材料名称" align="center">
      </el-table-column>
      <el-table-column label="完成进度" align="center">
        <template slot-scope="scope">
                     	  {{ scope.row.status | translate('pgress') }}
                     </template>
      </el-table-column>
      <el-table-column label="更新时间" align="center">
        <template slot-scope="scope">
                     	  {{ scope.row | translate('time') }}
                     </template>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
                                                                                                                                                                                                                                                         <el-button v-if="scope.row.status == 1" type="primary" @click="toEdit(scope.row,1)" size="mini">填表</el-button>
                                                                                                                                                                                                                                                         <el-button v-else type="danger" @click="toEdit(scope.row,2)" size="mini">修改</el-button>
                                                                                                                                                                                                                                                   </template>
                                                                                                                                                                                                                                    </el-table-column>
                                                                                                                                                                                                                                </el-table> -->

      <div class="subBar">
        <span v-if="pressType == 1">表2：音像制品出版情况表</span>
        <span v-if="pressType == 2">表2：电子出版物出版情况表</span>
      </div>

      <div class="tabArea">
        <table class="tabElement">
          <tr class="tabHead">
            <td>序号</td>
            <td>材料名称</td>
            <td>完成进度</td>
            <td>更新时间</td>
            <td colspan="2">操作</td>
          </tr>
          <tr v-for="(item, inx) in tabCage.tabDat3" :key="inx">
            <td>2-{{ inx + 1 }}</td>
            <td>{{ item.materialTitle }}</td>
            <td>{{ item.status | translate("pgress") }}</td>
            <td>{{ item | translate("time") }}</td>
            <td style="width: 120px">
              <el-button v-if="pubStatus == 0 && item.status == 1" type="primary" @click="toEdit(item, 1)" size="mini"
                >填表</el-button
              >
              <el-button v-if="pubStatus == 0 && item.status == 2" type="danger" @click="toEdit(item, 2)" size="mini"
                >修改</el-button
              >
              <el-button v-if="pubStatus == 1" type="primary" @click="toEdit(item, 3)" size="mini">查看</el-button>
            </td>
            <td style="width: 120px">
              <a href="javascript:void(0);" @click="dmyfile(3)" downLoad>
                <el-button size="mini">导出打印表</el-button>
              </a>
            </td>
          </tr>
        </table>
        <!-- <el-table :data="tabCage.tabDat3" border style="width: 100%">
      <el-table-column prop="date" label="序号" width="60" align="center">
        <template slot-scope="scope">2-1</template>
      </el-table-column>
      <el-table-column prop="materialTitle" label="材料名称" align="center">
      </el-table-column>
      <el-table-column label="完成进度" align="center">
        <template slot-scope="scope">
                     	  {{ scope.row.status | translate('pgress') }}
                     </template>
      </el-table-column>
      <el-table-column label="更新时间" align="center">
        <template slot-scope="scope">
                     	  {{ scope.row | translate('time') }}
                     </template>
      </el-table-column>
      <el-table-column label="操作" width="150" align="center">
        <template slot-scope="scope">
                                                                                                                                                                                                                                                         <el-button v-if="scope.row.status == 1" type="primary" @click="toEdit(scope.row,1)" size="mini">填表</el-button>
                                                                                                                                                                                                                                                         <el-button v-else type="danger" @click="toEdit(scope.row,2)" size="mini">修改</el-button>
                                                                                                                                                                                                                                                   </template>
                                                                                                                                                                                                                                    </el-table-column>
                                                                                                                                                                                                                                  </el-table> -->
        <div class="tabTips">
          <div class="tipBold">注：</div>
          <div class="tipLine">
            <span class="fsDot">1、</span>
            所有表格填写项目，若本单位无此项内容，文字项请填写“无”，数字项请填写“0”。
          </div>
          <div class="tipLine">
            <span class="fsDot">2、</span>
            核验年度如果没有发生表1-5、1-6、1-7、2-1的事项，则可以不用填写。
          </div>
          <div class="tipLine">
            <span class="fsDot">3、</span>
            表1-8可使用Excel进行批量导入。导入前需要先下载“导入模板”，并在“导入模板”文件中按其规定格式填写后才能批量导入。
          </div>
          <div class="tipLine">
            <span class="fsDot">4、</span>
            数据拷贝是指同时具有音像、电子业务的单位，在填写好音像材料后，两处材料一样的表格内容可以通过“数据拷贝”复制到电子出版物这边。
          </div>
          <div class="tipLine">
            <span class="fsDot">5、</span>
            导出打印表可以将标准格式Excel文件下载到本地电脑，下载的文件可以微调格式适应换行、换页后再打印，但不能修改内容。提交之后可从“核验进度”
            菜单导出打印表。
          </div>
        </div>

        <!-- <div class="tabTips" v-if="pressType == 2">
					<div>注：</div>
					<div class="tipLine">
						<span class="fsDot">1、</span> 表1-9可以在线填写，非独立法人在表5中的收入、利润填写“0”，需要先行填写表1再填写表5；核验年度内如果没有发生表7、表8、表9的统计事项，无须填写。
					</div>
					<div class="tipLine">
						<span class="fsDot">2、</span> 如需把材料导出为PDF，请在进入打印预览时，选择另存为PDF格式文件到本地电脑。
                                                                                                                                                                                                                              					</div>
                                                                                                                                                                                                                              					<div class="tipLine">
                                                                                                                                                                                                                              						<span class="fsDot">3、</span> 填表时若无此项请填写“无”。
                                                                                                                                                                                                                              					</div>
                                                                                                                                                                                                                              			</div> -->
      </div>
    </div>

    <div class="progressTab">
      <div class="headBar">
        <span>流转记录</span>
      </div>
      <el-table :data="tabDat" border style="width: 100%">
        <el-table-column label="序号" width="60" align="center" type="index"> </el-table-column>
        <el-table-column prop="examineName" width="250" label="单位" align="center"></el-table-column>
        <el-table-column prop="name" width="120" label="状态" align="center">
          <template slot-scope="scope">
            <!-- {{scope.row}} -->
            {{ scope.row | tansStr("state") }}
          </template>
        </el-table-column>
        <el-table-column prop="examineMessage" min-width="300" label="审核意见" align="center">
          <template slot-scope="scope">
            <div
              v-for="(item, index) in (scope.row.examineMessage || '').split('；')"
              :key="index"
              style="text-align: left">
              {{ item ? item + (index == (scope.row.examineMessage || "").split("；").length - 1 ? "" : "；") : "" }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="pubNumber" width="120" label="批准文号" align="center"></el-table-column>
        <el-table-column prop="checkdAt" width="150" label="操作时间" align="center">
          <template slot-scope="scope">
            <!-- {{scope.row}} -->
            {{ scope.row | tansStr("checkdAt") }}
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="subLine">
      <el-button v-if="pubStatus == 0" @click="upToPvc" type="danger">提交</el-button>
      <!-- <el-button @click="copyHandle('show')" type="danger">拷贝</el-button> -->
    </div>

    <el-dialog
      class="pressDiag"
      title="选择需要拷贝的表"
      :visible.sync="dialogVisible"
      width="450px"
      @close="handleClose">
      <div v-if="checkList && checkList.length > 0">
        <div class="tips">
          数据拷贝会覆盖现有已填写的数据，请谨慎操作！复制的内容如有微调不同，请点击“编辑”按钮进入修改。
        </div>
        <el-checkbox-group v-model="codeArr">
          <div v-for="(tab, index) in checkList" class="selectItem">
            <el-checkbox :label="tab.materialCode" :key="tab.id"
              >{{ "1-" + tab.materialCode.substr(2, 3) }} {{ tab.materialTitle }}</el-checkbox
            >
          </div>
        </el-checkbox-group>
      </div>
      <div class="errors" v-else>目前尚未生成可拷贝的表</div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="small">取 消</el-button>
        <el-button v-if="checkList && checkList.length > 0" type="primary" @click="copyHandle('act')" size="small"
          >拷 贝</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import UpBtn from "@/views/components/uploadBtn";
import { getFileToken, detFile } from "@/api/account";
import { subToPvc, getPressList, sUpdate0, copyList, copySet, getSelYearRecord } from "@/api/pressRole/pressRole";
import { expFile } from "@/api/export";
import { successiveHistoryNew } from "@/api/provinceRole/provinceRole";
export default {
  components: {
    UpBtn,
  },
  props: ["pressType", "pressDat"],
  data() {
    return {
      dialogVisible: false,
      checkList: [],
      codeArr: [],
      tabNameMap: {},
      // zym.列表页面不同区域的数据信息
      tabCage: {
        tabDat1: [],
        tabDat2: [],
        tabDat3: [],
      },
      // zym.文件上传信息存储（改造成数组）
      zeroStoreage: {},
      // zeroStoreage: {
      //   id: '',
      //   publishMaterialId: '',
      //   publishId: '',
      //   fileId: ''
      // },
      opMsg: "",
      // 核验状态
      msgStatus: "",
      // 是否整改阶段
      isModifyStage: "",
      postId: "",

      filrUrl1: "",
      filrUrl2: "",

      fileToken: "",
      loadUrl: "",

      printUrl1: "",
      printUrl2: "",
      printUrl3: "",

      selYear: "",
      selYearRecord: [{}],
      params: {},

      pubStatus: 0,

      //  审核历史
      tabDat: [],
    };
  },
  filters: {
    tansStr: function (dat, code) {
      if (code == "state") {
        // console.log('state=',dat.flowName,'  ' ,dat.status)
        // console.log('state=',dat.flowName,'  ' ,dat.status)
        if (dat.flowName == "开始") {
          let map = {
            0: "开始",
            7: "提交",
            // 21: "暂缓登记",
          };
          // console.log("dat.status=", dat.status, "  ", map[dat.status]);
          return map[dat.status];
        } else if (dat.flowName == "省局") {
          let map = {
            1: "通过",
            3: "退回",
            9: "整体上报",

            12: "暂缓",
            13: "注销或拟注销",
            14: "建议撤销",
            21: "暂缓登记",
          };
          return map[dat.status];
        } else if (dat.flowName == "国家新闻出版署") {
          let map = {
            1: "通过",
            2: "暂缓",
            3: "退回",
            4: "撤销",
            5: "注销或拟注销",
            10: "整体退回",
            9: "整体发布",
            22: "暂缓登记",
            21: "暂缓登记",
          };

          return map[dat.status];
        } else if (dat.flowName == "登记") {
          let map = {
            0: "待登记",
            1: "待登记",
            2: "已登记",
          };

          return map[dat.status];
        } else {
          return dat.flowName;
        }
      } else if (code == "checkdAt") {
        if (dat["checkdAt"] == "Invalid date") {
          return "";
        }
        return dat["checkdAt"].substr(0, 16);
      }
    },
    translate: function (dat, code) {
      if (code == "pgress") {
        let transArr = ["未提交", "已提交"];
        return transArr[dat - 1];
      } else if (code == "time") {
        if (dat.status == 2) {
          return dat.updatedAt.substr(0, 16);
        } else {
          return "";
        }
      }
    },
  },
  methods: {
    valChange: function () {
      if (this.selYear != undefined) {
        sessionStorage.setItem("selYear", this.selYear);
      }
      this.$emit("valChangeSearch", this.selYear);
    },
    toEdit: function (row, type) {
      let urlMap = {
        // 基本情况表
        201: "edit_tab1",
        // 资质情况表 ———— 电子出版物出版许可证
        202: "edit_tab2",
        // 经营情况表
        203: "edit_tab3",
        // 经营场所情况表
        204: "view_tab4",
        // 获得表彰情况登记表
        205: "view_tab5",
        // 重点电子出版物情况登记表
        206: "view_tab6",
        // 受处罚情况表
        207: "edit_tab7",
        // 人员基本情况登记表
        208: "view_tab8",
        301: "view_tab9",

        209: "edit_tab10", // zym.20230404新增
      };
      if (type == 1) {
        this.$router.push({
          path: urlMap[row.materialCode],
          query: {
            pressId: row.organizationId,
            mtId: row.id,
            pressType: this.pressType,
            pgress: 1,
            pubStatus: 0,
          },
        });
      } else if (type == 2) {
        this.$router.push({
          path: urlMap[row.materialCode],
          query: {
            pressId: row.organizationId,
            mtId: row.id,
            pressType: this.pressType,
            pgress: 2,
            pubStatus: 0,
          },
        });
      } else if (type == 3) {
        // 只能查看
        this.$router.push({
          path: urlMap[row.materialCode],
          query: {
            pressId: row.organizationId,
            mtId: row.id,
            pressType: this.pressType,
            pgress: 2,
            pubStatus: 1,
          },
        });
      }
    },

    // 复制表
    copyHandle: function (code) {
      let vm = this;
      if (code == "show") {
        this.dialogVisible = true;
        copyList({
          type: vm.pressType,
        }).then((response) => {
          vm.checkList = response.synchroCodeList;
        });
      } else if (code == "act") {
        copySet({
          type: vm.pressType,
          codes: vm.codeArr,
        }).then((response) => {
          this.$message.success("拷贝成功");
          this.dialogVisible = false;
          this.$emit("go-frash");
        });
      }
    },

    handleClose: function () {
      this.checkList = [];
      this.codeArr = [];
      this.dialogVisible = false;
    },

    // zym.流转记录
    historyRecord: function () {
      let dat = this.pressDat[0];
      this.examineId = dat.id;
      // console.log("流转记录：", this.examineId, " 年度：", this.selYear);

      successiveHistoryNew({ examineId: this.examineId, year1: this.selYear }).then((response) => {
        let flowData = response.fFlowTaskList;
        this.tabDat = flowData.filter((item) => {
          if (item.flowName == "国家新闻出版署") {
            if (item.status == "1") {
              return true;
            } else {
              return false;
            }
          } else {
            return true;
          }
        });
      });
    },

    // zym.他是通用的，感觉this.zeroStoreage使用有问题，因为这个地方有两个文件
    // zym.上传完成后，更新文件上传的信息
    // zym.dat = 上传之后，返回来的fileId
    zeroStoreCtrls: function (dat, btnProps) {
      // console.log("dat=", dat);
      console.log("btnProps=", JSON.stringify(btnProps));

      let btnKey = btnProps.id;
      let materialTitle = btnProps.materialTitle;

      console.log("this.zeroStoreage[btnKey]=", JSON.stringify(this.zeroStoreage[btnKey]));

      let detAble, idOld, publishMaterialId;
      if (this.zeroStoreage[btnKey]) {
        detAble = this.zeroStoreage[btnKey].fileId;
        idOld = this.zeroStoreage[btnKey].id;
        publishMaterialId = this.zeroStoreage[btnKey].publishMaterialId;
      }

      let vm = this;
      this.zeroStoreage[btnKey].fileId = dat;
      sUpdate0({
        id: idOld,
        publishMaterialId: publishMaterialId,
        fileId: dat,
        materialTitle: materialTitle, // zym.新增。20250609，备注：用来标记是整改报告，还是自查报告
        // pfile1: this.zeroStoreage
      })
        .then((response) => {
          console.log("sUpdate0 file = ", JSON.stringify(response));
          let code = response.payload.tipCode;
          let msg = response.payload.message;
          if (code != "success") {
          }
          // zym.成功，需要刷新页面
          else {
            vm.$emit("go-frash");
          }
          // vm.zeroStoreage.id = response.pfile1.id;
          // this.$emit('go-frash');
          // if (detAble) {
          //   detFile({
          //     id: detAble
          //   }).then(inresp => {
          //     this.$emit('go-frash');
          //   })
          // } else {
          //   vm.zeroStoreage.id = response.pfile1.id;
          //   this.$emit('go-frash');
          // }
        })
        .catch((error) => {});
    },

    saveZeroStoreage: function (publishMaterialId, publishId, fileId) {
      this.zeroStoreage[publishMaterialId] = {
        publishMaterialId,
        publishId,
        fileId,
      };
    },

    saveFileId: function (tabDat1Item, zichaReportFileId, zhenggaiReportFileId) {
      let zgbgPublishMaterialId, zcbgPublishMaterialId;
      if (tabDat1Item.materialTitle == "整改报告") {
        // 整改报告
        zgbgPublishMaterialId = tabDat1Item.id;
        this.saveZeroStoreage(zgbgPublishMaterialId, tabDat1Item.organizationId, zhenggaiReportFileId);
      } else {
        // 有时候不叫自查报告 而是工作报告（
        zcbgPublishMaterialId = tabDat1Item.id;
        this.saveZeroStoreage(zcbgPublishMaterialId, tabDat1Item.organizationId, zichaReportFileId);
      }
    },
    // zym.数据获取之后，页面其他信息初始化
    pressInit: function () {
      let dat = this.pressDat[0];
      // console.log('pressInit: ', JSON.stringify(dat))
      let vm = this;
      if (dat.reportUploadList) {
        // 是否出版社阶段，比对的是progress（CONST.TASKTYPE.START.value），如果是出版社阶段返回0，否则返回1
        this.pubStatus = dat.pubStatus;
        this.tabCage.tabDat1 = dat.reportUploadList;
        this.tabCage.tabDat2 = dat.yearVerificationList;
        this.tabCage.tabDat3 = dat.licenseUploadList;

        console.log("文件材料信息: ", JSON.stringify(this.tabCage.tabDat1));
        console.log("dat.pFile1: ", JSON.stringify(dat.pFile1));
        console.log("dat.pFile2: ", JSON.stringify(dat.pFile2));

        // 退回消息
        this.opMsg = dat.msg;
        // 状态
        this.msgStatus = dat.msgStatus;
        this.isModifyStage = dat.isModifyStage;
        this.postId = dat.reportUploadList[0].materialExamineId;

        console.log("publishMaterialId1=", this.tabCage.tabDat1[0].id);
        console.log("publishMaterialId2=", this.tabCage.tabDat2[0].id);

        // zym.因为整改报告、自查报告都是 code=101，所以根据材料名称做个判断
        let zichaReportFileId = undefined;
        let zhenggaiReportFileId = undefined;
        if (dat.pFile1 && dat.pFile1.length > 0) {
          console.log("到达file1...");
          zichaReportFileId = dat.pFile1[0].id;
        }

        if (dat.pFile2 && dat.pFile2.length > 0) {
          console.log("到达file2...,", dat.pFile2[0].id, ",", this.tabCage.tabDat1[1].id);
          zhenggaiReportFileId = dat.pFile2[0].id;
        }

        this.saveFileId(this.tabCage.tabDat1[0], zichaReportFileId, zhenggaiReportFileId);
        if (this.tabCage.tabDat1[1] != undefined) {
          this.saveFileId(this.tabCage.tabDat1[1], zichaReportFileId, zhenggaiReportFileId);
        }

        // 调节顺序
        if (this.tabCage.tabDat1[0].materialTitle == "整改报告") {
          // 有整改必有自查
          let tabDatTmp = this.tabCage.tabDat1[0];
          this.tabCage.tabDat1[0] = this.tabCage.tabDat1[1];
          this.tabCage.tabDat1[1] = tabDatTmp;
        }

        // console.log('this.zeroStoreage=',JSON.stringify(this.zeroStoreage));
        getFileToken().then((response) => {
          vm.printUrl1 =
            process.env.BASE_API +
            "/File/File/printYxdzJbxx?type=" +
            vm.pressType +
            "&organizationId=" +
            vm.tabCage.tabDat2[0].organizationId +
            "&token=" +
            encodeURIComponent(vm.$store.getters.token);
          vm.printUrl2 =
            process.env.BASE_API +
            "/File/File/printRyJbxx?type=" +
            vm.pressType +
            "&publishMaterialId=" +
            vm.tabCage.tabDat2[7].id +
            "&token=" +
            encodeURIComponent(vm.$store.getters.token);
          vm.printUrl3 =
            process.env.BASE_API +
            "/File/File/printYxdzCbwqkb?type=" +
            vm.pressType +
            "&publishMaterialId=" +
            vm.tabCage.tabDat3[0].id +
            "&organization=" +
            encodeURIComponent(vm.$store.getters.name) +
            "&token=" +
            encodeURIComponent(vm.$store.getters.token);
        });
      }

      this.setYearArray();
    },
    // 设置年份（废弃掉，直接选择当前年份的即可）
    setYearArray: function () {
      this.selYear = this.$store.getters.userInfo.year1;
      // let that = this;
      // getSelYearRecord({
      //   publishId: this.tabCage.tabDat2[0].organizationId,
      //   type: this.pressType,
      // }).then((response) => {
      //   console.log("======", response);
      //   let arr = [];
      //   let yearList = response.generalPublisher;
      //   if (yearList.length > 0) {
      //     let po = yearList[yearList.length - 1];
      //     that.params.year1 = po.firstYear;
      //     that.selYear = po.firstYear;
      //     // for (let i = 0; i < response.generalPublisher.length; i++) {
      //     //   let po = response.generalPublisher[i];
      //     //   arr.push({ label: po.firstYear + "~" + po.secondYear, value: po.firstYear });
      //     //   if (response.generalPublisher.length - 1 == i) {
      //     //     that.params.year1 = po.firstYear;

      //     //     let cacheYear = sessionStorage.getItem("selYear");
      //     //     if (cacheYear !== null && cacheYear !== "") {
      //     //       that.selYear = cacheYear;
      //     //     } else {
      //     //       that.selYear = po.firstYear;
      //     //     }
      //     //   }
      //     // }
      //   }
      //   that.selYearRecord = arr;
      // });
    },
    dmyfile: function (exp, obj) {
      var params = {};
      var expUrl = "";
      if (exp == 1) {
        expUrl = "/api/export/printYxdzJbxx";
        params = {
          firstYear: this.selYear,
          type: this.pressType,
          organizationId: this.tabCage.tabDat2[0].organizationId,
        };
      } else if (exp == 2) {
        expUrl = "/api/export/printRyJbxx";
        params = {
          firstYear: this.selYear,
          type: this.pressType,
          publishMaterialId: this.tabCage.tabDat2[7].id,
          organization: encodeURIComponent(this.$store.getters.name),
          organizationId: this.tabCage.tabDat2[0].organizationId,
        };
      } else if (exp == 3) {
        expUrl = "/api/export/printYxdzCbwqkb";
        params = {
          firstYear: this.selYear,
          type: this.pressType,
          publishMaterialId: this.tabCage.tabDat3[0].id,
          organization: encodeURIComponent(this.$store.getters.name),
          organizationId: this.tabCage.tabDat2[0].organizationId,
        };
      } else if (exp == 4) {
        expUrl = "/api/export/download";
        params = {
          id: this.pressDat[0].pFile1.fileId,
        };
      }
      expFile({ expUrl: expUrl, p: params })
        .then((blob) => {
          let blobHref = window.URL.createObjectURL(blob);
          let anchor = document.createElement("a");
          anchor.href = blobHref;
          var fname = localStorage.getItem("dfilename");
          anchor.download = decodeURIComponent(fname);
          document.body.appendChild(anchor);
          anchor.click();
          window.URL.revokeObjectURL(blobHref);
          document.body.removeChild(anchor);
        })
        .catch((error) => {});
    },
    goFrash: function () {
      this.$emit("go-frash");
    },

    upToPvc: function () {
      let vm = this;
      this.$confirm("确定所需填报表格已填写完成，并提交省局吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const loading = vm.$loading({
            lock: true,
            text: "处理中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });

          subToPvc({
            materialExamineId: this.postId,
            // type: 1 // zym.type类型不能要，音像、电子共用接口，nodejs根据examine来判断哪种类型
          }).then((response) => {
            loading.close();
            console.log("response=", JSON.stringify(response));
            let tipCode = response.payload.tipCode;
            let tipMessage = response.payload.message || "操作失败";
            if (tipCode == "fail") {
              this.$message({
                showClose: true,
                message: tipMessage,
                type: "error",
              });
            } else {
              this.$message({
                message: "操作成功！",
                type: "success",
              });
              this.$router.push("pgress_step");
            }
          });
        })
        .catch(() => {});
    },
  },
  watch: {
    pressDat(curVal, oldVal) {
      this.pressInit();

      // 流转记录
      this.historyRecord();
    },
  },
  created: function () {
    // this.filrUrl1 = process.env.BASE_API + '/File/File/downloadDrmb?code=0011&token=' + encodeURIComponent(this.$store.getters.token);
    // this.filrUrl2 = process.env.BASE_API + '/File/File/downloadDrmb?code=0012&token=' + encodeURIComponent(this.$store.getters.token);
    this.filrUrl1 = process.env.URL_FILE + "/drmb/001.xlsx"; // 封面和盖章页
    this.filrUrl2 = process.env.URL_FILE + "/drmb/002.xlsx"; // 封面和盖章页
    // this.filrUrl1 = process.env.BASE_API + '/drmb/001.xlsx // 封面和盖章页';

    // 之后再重设选择年份
    // let cacheYear = sessionStorage.getItem("selYear");
    // if (cacheYear != null && cacheYear != "") {
    //   if (cacheYear != this.selYear) {
    //     this.selYear = cacheYear;
    //     this.valChange();
    //     return;
    //   }
    // }

    // 年份设置为固定当年的
    this.selYear = this.$store.getters.userInfo.year1;

    this.pressInit();

    // 流转记录
    this.historyRecord();
  },
};
</script>

<style lang="scss" scoped type="text/css">
.pressTabList {
  font-size: 14px;
  letter-spacing: 0.72px;

  .subLine {
    text-align: center;
    margin: 0 0 50px;

    .el-button {
      width: 180px;
      margin-top: 12px;
    }
  }

  .copyBtn {
    float: right;
    margin-top: 9px;
    margin-left: 6px;
  }

  .downBtn {
    float: right;
  }

  .selectItem {
    margin-top: 6px;
    margin-left: 12px;
  }

  .rejects {
    border: 1px solid red;
    color: red;
    padding: 15px 0;
    border-radius: 3px;

    .rejLine {
      position: relative;
      line-height: 20px;

      .rejName {
        width: 70px;
        text-align: right;
        float: left;
      }

      .rejText {
        margin-left: 65px;
      }
    }
  }

  .headBar {
    padding: 0 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    margin-top: 9px;
    color: #666666;
  }

  .tabArea {
    margin-top: 12px;
    padding-bottom: 24px;

    .tabElement {
      width: 100%;

      .tabHead {
        font-size: 14px;
        font-weight: bold;

        td {
          // background: #f5f7fa;
          padding: 15px 20px;
          color: #909399;
        }
      }

      td {
        border-collapse: collapse;
        border: 1px solid #ebeef5;
        text-align: center;
        padding: 12px;
        color: #606266;
      }
    }

    .tabTips {
      font-size: 14px;
      color: #464646;
      margin-top: 9px;
      line-height: 1.5em;

      .tipBold {
        font-weight: bold;
      }
      .tipLine {
        padding-left: 20px;
        position: relative;

        .fsDot {
          width: 45px;
          position: absolute;
          left: 0;
        }
      }
    }
  }

  .subBar {
    padding: 0 24px;
    height: 45px;
    line-height: 45px;
    background: #f8f8f8;
    margin-top: 6px;
    color: #666666;
  }
}
</style>

<style>
.pressDiag .el-dialog__body {
  padding: 6px 30px !important;
}

.pressDiag .tips {
  padding-left: 6px;
  margin-bottom: 12px;
  font-size: 12px;
  color: salmon;
}

.pressDiag .errors {
  font-size: 15px;
  color: #999999;
  padding-top: 6px;
}
</style>



// WEBPACK FOOTER //
// CommonTab.vue?a4c29fc8